import type { Option } from "./gulaConstants";

/** Cash is collected in person, which only our own installers in Catalonia do. */
export const CASH_METHOD = "cash";

/** Postal code prefixes of Barcelona, Girona, Lleida and Tarragona. */
const CATALONIA_PREFIXES = ["08", "17", "25", "43"];

/**
 * The delivery address is in Catalonia. The postal code typed in the sale
 * wins; without one, the zone the lead already has.
 */
export const isInCatalonia = (
  postalCode?: string | null,
  zone?: string | null,
): boolean => {
  const code = (postalCode ?? "").replace(/\D/g, "");
  if (code.length >= 2) return CATALONIA_PREFIXES.includes(code.slice(0, 2));
  return zone === "Cataluña";
};

/** Payment options for a sale: cash only when the address is in Catalonia. */
export const paymentOptionsFor = (
  options: Option[],
  inCatalonia: boolean,
): Option[] =>
  inCatalonia ? options : options.filter((o) => o.value !== CASH_METHOD);
